import { useEffect,useState,useRef, useMemo, useCallback } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { RESULTS_LOADING_LIMIT_IN_SECONDS } from 'arbitrip-common/general/constants/search-constants';
import CheckIcon from '@mui/icons-material/Check';
const duration_in_millis = RESULTS_LOADING_LIMIT_IN_SECONDS * 1000;
const SEQUENCE_TIMEOUT = 2000;

const SequenceProgress = ({ results, searchSessionCreatedTimestamp, onDealsLoaded, t})=>{
    
    const interval = useRef(null);
    const [ stage,setStage] = useState(0);
    const [done, setDone] = useState(false);

        const sequence = [t('SequenceStages.FindingPrices'),
                          t('SequenceStages.TestingPillows'),
                          t('SequenceStages.CountingSnacks'),
                          t('SequenceStages.FinalizingResults')
                         ]

    const getResultsCoverage = useCallback(() => {
        if (results?.hotels?.length) {
            const nonShallow = results.hotels.filter(h => !h.shallow);
            if (!nonShallow.length) return 0;
            const withDeals = nonShallow.filter(h => h.representativeDeal).length;
            return withDeals / nonShallow.length;
        }
        return 0;
    },[results,searchSessionCreatedTimestamp]);

    const getStageFromProgress = useCallback(() => {
        if (!searchSessionCreatedTimestamp) return 0;
        const elapsed = Date.now() - new Date(searchSessionCreatedTimestamp).getTime();
        const coverage = getResultsCoverage();
        const multiplier = 1 + coverage ** 2;
        const progress = Math.min(100, (elapsed / duration_in_millis) * 100 * multiplier);

        const segment = 100 / (sequence.length - 1);
        return Math.min(sequence.length - 1, Math.floor(progress / segment));
    },[searchSessionCreatedTimestamp, getResultsCoverage, sequence.length]);

    const getStageFromProgressRef = useRef(getStageFromProgress);
    getStageFromProgressRef.current = getStageFromProgress;

      useEffect(() => {
            if (!searchSessionCreatedTimestamp) return;

            interval.current = setInterval(() => {
                setStage(prev => (prev + 1) % sequence.length);

                const progressStage = getStageFromProgressRef.current();
                if (progressStage === sequence.length - 1) {
                    clearInterval(interval.current);
                    setDone(true);
                    setTimeout(onDealsLoaded, 400);
                }
                }, SEQUENCE_TIMEOUT );

        return () => clearInterval(interval.current);
    }, [searchSessionCreatedTimestamp]);

    const text = done ? t('SequenceStages.Done') : sequence[stage];

    return (<div className="sequence-progress-container">
                 { !done && <CircularProgress className="mui-sequence-spinner" size={24} />}
                 { done && <CheckIcon className="mui-sequence-check" />}
                 <span className="sequence-text">{text}</span>
            </div>)
}
export default SequenceProgress;